<!-- 微信申请审批 -->
<template>
  <a-card :bordered="false">
    <a-tabs default-active-key="1" @change="callback">
      <a-tab-pane key="1" :tab="$t('待办')">
        <Unprocessed />
        <!-- <WeChatListUnProcessed /> -->
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('已办')" force-render>
        <Completed />
        <!-- <WeChatListCompleted /> -->
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>

  import Unprocessed from './unprocessed'
  import Completed from './completed'

  export default {
    name: 'WeChatApplicationApproval',
    components: {
      Unprocessed,
      Completed
    },
    data () {
      return {}
    },
    methods: {
      callback (key) {
        // tab 切换,内容由子组件自管,无需额外处理
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>